// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER



//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }

// //
// // =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// // --------------------------------------------------

// $(".msdw-page-scroll").click(function () {
//   if (
//     location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
//     location.hostname == this.hostname
//   ) {
//     var target = $(this.hash);
//     target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
//     if (target.length) {
//       var offsetValue = 0;
//       if (window.innerWidth <= 767) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $("html,body").animate(
//         {
//           scrollTop: target.offset().top - offsetValue,
//         },
//         900
//       );
//       return false;
//     }
//   }
// });

//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));

//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

var swiperXtransition = new Swiper(".swiper-xtransition", {
    slidesPerView: 1,
    pagination: false,
    loop: true,
    navigation: {
      prevEl: '.msdw-swiper-button-prev',
      nextEl: '.msdw-swiper-button-next',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    },
  });

  // const sliderTechs = new Swiper("#sliderTechs", {
  //   slidesPerView: 1.2,
  //   spaceBetween: 10,
  //   freeMode: true,
  //   grabCursor: true,
  //   breakpoints: {
  //     600: {
  //       slidesPerView: 1.8,
  //       spaceBetween: 15,
  //     },
  //     900: {
  //       slidesPerView: 4,
  //       spaceBetween: 20,
  //       grabCursor: false,
  //       noSwipingClass: "no-swipe",
  //     },
  //   },
  // });

  const sliderCarryingSystems = new Swiper("#sliderCarryingSystems", {
    slidesPerView: 1.333,
    spaceBetween: 10,
    freeMode: true,
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 15,
        freeMode: false,
        navigation: {
          prevEl: ".swiper-systems-button-prev",
          nextEl: ".swiper-systems-button-next",
        },
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 20,
        freeMode: false,
        navigation: {
          prevEl: ".swiper-systems-button-prev",
          nextEl: ".swiper-systems-button-next",
        },
      },
    },
  });


//
// =VIDEO POP-UP
// --------------------------------------------------
const playVideoBtns = document.querySelectorAll(".msdw-play-video");
const msdwPopupVideoWrapper = document.querySelector(
  ".msdw-popup-video-wrapper"
);
const msdwPopupVideoBackDrop = document.querySelector(
  ".msdw-popup-video-backdrop"
);
const msdwPopupVideo = document.getElementById("msdwPopupVideo");
if (document.contains(msdwPopupVideoWrapper)) {
  // OPEN
  playVideoBtns.forEach((playVideoBtn) => {
    playVideoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = playVideoBtn.getAttribute("data-modal-video");
      msdwPopupVideo.setAttribute("src", videoUrl);
      msdwPopupVideoWrapper.classList.add("msdw-active");
      document.body.classList.add("jws-overflowHidden");
      msdwPopupVideo.muted = false;
      msdwPopupVideo.play();
    });
  });
  // CLOSE
  const closePopUpVideo = () => {
    document.body.classList.remove("jws-overflowHidden");
    msdwPopupVideo.muted = true;
    msdwPopupVideo.pause();
    msdwPopupVideo.currentTime = 0;
    msdwPopupVideoWrapper.classList.remove("msdw-active");
  };
  msdwPopupVideoBackDrop.addEventListener("click", () => {
    closePopUpVideo();
  });
  window.onkeydown = (e) => {
    if (e.keyCode == 27) closePopUpVideo();
  };
}
